<template>
<div>
    							
    <div>
        <font style="color: red;" v-if="tb.ismust">*</font>
        <font>{{tb.name}} </font>
    </div>
    <div class="weui-cells weui-cells_form">
        <div class="weui-cell ">
            <div class="weui-cell__bd">
                <textarea class="weui-textarea" :placeholder="'请输入'+tb.name" :rows="tb.rows" v-model="tb.val"></textarea>
                <a v-if="tb.val" @click="overwrite" style="position: absolute;right: 0;"><i class="weui-icon-clear"></i></a> 
            </div>
        </div>
    </div>

    <br>
</div>
</template>


<script>
    
export default{
    props:['tb'],
    methods:{
        overwrite(){
            this.tb.val = '';
        }
    }
}
</script>


<style>

</style>


// WEBPACK FOOTER //
// src/fields/TextArea.vue